import React, { useState } from 'react';
import PasswordStrength from '../shared/PasswordStrength';
import PhoneInput from '../shared/PhoneInput';
import AddressAutocomplete from '../shared/AddressAutocomplete';

export default function PasswordChangePage({ onComplete }) {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [address, setAddress] = useState('');
  const [addressData, setAddressData] = useState(null);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    if (newPassword.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    onComplete();
  };

  const inputStyle = {
    width: '100%', padding: '10px 14px', background: 'var(--bg)',
    border: '1px solid var(--border)', borderRadius: 8, color: 'var(--text)',
    fontSize: 14, outline: 'none', boxSizing: 'border-box'
  };

  const labelStyle = {
    display: 'block', color: 'var(--text-secondary)', fontSize: 13,
    fontWeight: 600, marginBottom: 6
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg)', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{
        width: '100%', maxWidth: 480, padding: 40, background: 'var(--card)',
        borderRadius: 16, border: '1px solid var(--border)', boxShadow: '0 8px 32px rgba(0,0,0,0.3)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{
            width: 56, height: 56, borderRadius: 14, background: 'var(--primary)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 14px', fontSize: 24, color: '#fff'
          }}>
            &#128274;
          </div>
          <h1 style={{ color: 'var(--text)', fontSize: 22, fontWeight: 700, margin: '0 0 6px' }}>
            Change Your Temporary Password
          </h1>
          <p style={{ color: 'var(--text-muted)', fontSize: 13, margin: 0 }}>
            __BRAND_NAME__ requires a secure password before continuing
          </p>
        </div>

        {error && (
          <div style={{
            padding: '10px 14px', marginBottom: 18, borderRadius: 8,
            background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)',
            color: '#ef4444', fontSize: 13
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={labelStyle}>New Password</label>
            <input
              className="input"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Minimum 8 characters"
              required
              style={inputStyle}
            />
            <PasswordStrength password={newPassword} />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={labelStyle}>Confirm Password</label>
            <input
              className="input"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Re-enter your new password"
              required
              style={inputStyle}
            />
            {confirmPassword && confirmPassword !== newPassword && (
              <div className="field-error" style={{ marginTop: 4 }}>Passwords do not match</div>
            )}
            {confirmPassword && confirmPassword === newPassword && newPassword.length >= 8 && (
              <div style={{ fontSize: 12, color: 'var(--success)', marginTop: 4, fontWeight: 500 }}>Passwords match</div>
            )}
          </div>

          <div style={{
            height: 1, background: 'var(--border)', margin: '20px 0'
          }} />

          <p style={{ color: 'var(--text-muted)', fontSize: 12, marginBottom: 14 }}>
            Please provide your contact information for your team profile.
          </p>

          <div style={{ marginBottom: 16 }}>
            <label style={labelStyle}>Phone Number</label>
            <PhoneInput
              value={phone}
              onChange={(formatted) => setPhone(formatted)}
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={labelStyle}>Mailing Address</label>
            <AddressAutocomplete
              value={address}
              onChange={(val) => setAddress(val)}
              onSelect={(place) => {
                setAddress(place.formatted || place.street);
                setAddressData(place);
              }}
              placeholder="Start typing your address..."
              style={{ width: '100%' }}
            />
          </div>

          <button
            className="btn btn-primary"
            type="submit"
            style={{
              width: '100%', padding: '12px 0', background: 'var(--primary)', color: '#fff',
              border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer'
            }}
          >
            Save &amp; Continue
          </button>
        </form>
      </div>
    </div>
  );
}
